"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter_1 = require("../Event/EventEmitter");
var StateMachine = /** @class */ (function () {
    function StateMachine() {
        this.states = {};
        this.eventEmitter = new EventEmitter_1.default();
        this.timeout = undefined;
    }
    StateMachine.prototype.getCurrentState = function () {
        return this.currentState;
    };
    StateMachine.prototype.setCurrentState = function (label, params, timeoutMilliseconds) {
        var _this = this;
        if (timeoutMilliseconds === void 0) { timeoutMilliseconds = 0; }
        if (!(label in this.states)) {
            throw new Error('unable to set unknown state [' + label + ']');
        }
        if (this.timeout) {
            return;
        }
        if (timeoutMilliseconds > 0) {
            this.timeout = setTimeout(function () {
                _this.timeout = undefined;
            }, timeoutMilliseconds);
        }
        this.currentState = this.states[label];
        this.currentState.entry(params);
        this.emit('state', label);
    };
    StateMachine.prototype.addState = function (state) {
        var label = state.label;
        this.states[label] = state;
    };
    StateMachine.prototype.update = function (params) {
        if (this.currentState) {
            this.currentState.update(params);
        }
    };
    StateMachine.prototype.on = function (event, handler) {
        return this.eventEmitter.on(event, handler);
    };
    StateMachine.prototype.emit = function (event, data) {
        this.eventEmitter.emit(event, data);
    };
    return StateMachine;
}());
exports.default = StateMachine;
//# sourceMappingURL=StateMachine.js.map